import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationExtras, Router, RouterModule } from '@angular/router';
import { EventService } from '@common/event.service';
import { RoutingService } from '@common/routing.service';
import { IdentityClientService } from '@identity/identity-client.service';
import { TranslateModule } from '@ngx-translate/core';
import { SharedConstants } from '@shared/constants';

@Component({
    selector: 'back-button',
    standalone: true,
    imports: [RouterModule, TranslateModule],
    templateUrl: './back-button.component.html',
    styleUrl: './back-button.component.scss'
})
export class BackButtonComponent {
    @Input() customStateBack?: { name: string, params?: any };

    private destroyRef = inject(DestroyRef);

    showBack: boolean = false;
    stateBack: { name: string, params?: any, navigationExtras?: NavigationExtras } = { name: '', params: null, navigationExtras: {} };
    private clientUrl!: string;
    //private currentState: { name: string, params?: any } = { name: '', params: null };
    //private previousState: { name: string, params?: any } = { name: '', params: null };

    constructor(
        private router: Router,
        private routingService: RoutingService,
        private activatedRoute: ActivatedRoute,
        private eventService: EventService,
        private identityClientService: IdentityClientService
    ) {
        this.clientUrl = this.identityClientService.get().url;
    }

    ngOnInit() {
        this.eventService.getEvent(SharedConstants.UPDATE_BACK_BUTTON_EVENT)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(resp => this.updateStateBack(resp))
    }

    goBack(event?: Event): void {
        if (event) {
            event.preventDefault();
        }

        if (this.stateBack !== undefined && this.stateBack !== null && this.stateBack.name !== undefined) {
            this.router.navigate([`/${this.clientUrl}/${this.stateBack.name}`, this.stateBack.params ?? {}], this.stateBack.navigationExtras)
        }
        else {
            const previousUrl = this.routingService.getPreviousUrl();
            this.router.navigateByUrl(previousUrl);
        }
    }


    get backLinkUrl(): string {
        if (this.stateBack !== undefined && this.stateBack?.name) {
            return `/${this.clientUrl}/${this.stateBack.name}`;
        } else {
            return this.routingService.getPreviousUrl() ?? '/'; // fallback
        }
    }


    updateStateBack(params: any = null) {
        this.stateBack = params !== null ? params.stateBack : null;
        this.showBack = params.showBack ?? false;
    }
}
